'use client'

import { useEffect, useState } from 'react'

interface CountdownTime {
  days: number
  hours: number
  minutes: number
  seconds: number
  formatted: string
}

export function useCountdown(targetDate: Date): CountdownTime {
  const [timeLeft, setTimeLeft] = useState<CountdownTime>({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    formatted: '00d 00:00:00'
  })

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date()
      let diff = Math.max(0, targetDate.getTime() - now.getTime())

      const days = Math.floor(diff / (1000 * 60 * 60 * 24))
      diff -= days * (1000 * 60 * 60 * 24)
      const hours = Math.floor(diff / (1000 * 60 * 60))
      diff -= hours * (1000 * 60 * 60)
      const minutes = Math.floor(diff / (1000 * 60))
      diff -= minutes * (1000 * 60)
      const seconds = Math.floor(diff / 1000)

      const formatted = `${String(days).padStart(2, '0')}d ${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`

      setTimeLeft({ days, hours, minutes, seconds, formatted })
    }, 1000)

    return () => clearInterval(timer)
  }, [targetDate])

  return timeLeft
}
